import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import App from './App';

// Disable browser scroll restoration and scroll to top immediately
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);

createRoot(document.getElementById('root')!).render(<App />);
